export default __webpack_public_path__ + "static/media/Happile1.8e247571.jpg";